import React, { useState } from "react";
// material
import { Stack, Button, Box, useMediaQuery, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { parseEther } from "@ethersproject/units";
import { ETH_VAL } from "../../constants";
import "./Mint.css";
import MemberWhiteList from "../member_whitelist.json";
import ChildTitle from "../ChildTitle";
import MintButton from "../MintButton";

// ----------------------------------------------------------------------
const ContainerStyle = styled("div")(({ theme }) => ({
  padding: "15px",
  borderBottom: "1px solid #ffffff80",
}));

const TitleStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "70px",
  fontFamily: "Helvetica",
}));

const SubTitleStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "30px",
  fontFamily: "Helvetica",
}));

const ContentStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "20px",
  fontFamily: "Helvetica",
  lineHeight: 1.2,
  paddingBottom: "15px",
}));

const TextFlowStyle = styled("div")(({ theme }) => ({
  overflow: "hidden",
  backgroundColor: "#fff",
  width: "100%",

  "@keyframes scrolling-left1": {
    "0%": {
      transform: "translateX(100%)",
    },
    "100%": {
      transform: "translateX(-100%)",
    },
  },

  "@keyframes scrolling-left2": {
    "0%": {
      transform: "translateX(0%)",
    },
    "100%": {
      transform: "translateX(-200%)",
    },
  },
}));

const TextFlowContentStyle = styled("p")(({ theme }) => ({
  fontFamily: "Helvetica",
  color: "#000",
  width: "100%",
  whiteSpace: "nowrap",
  padding: "8px 0",
}));

const TextAStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left1 40s linear infinite",
}));

const TextBStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left2 40s linear infinite",
  animationDelay: "20s",
}));
// ----------------------------------------------------------------------

export default function MintContent({
  address,
  userSigner,
  localProvider,
  mainnetProvider,
  price,
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
  blockExplorer,
  contract,
  remainTokenCount,
  remainMintCount,
  saleStatus,
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  const [amount, setAmount] = useState(ETH_VAL);
  const [minting, setMinting] = useState(false);
  const [mintCount, setMintCount] = useState(1);

  const _decreaseMintCount = () => {
    if (mintCount === 1) return;
    setMintCount(mintCount - 1);
  };

  const _increaseMintCount = () => {
    if (remainMintCount < 1) {
      setMintCount(1);
      return;
    }
    if (mintCount >= remainMintCount) {
      setMintCount(remainMintCount);
      return;
    }
    setMintCount(mintCount + 1);
  };

  const notify = (message) => toast(message);

  const mintNftHandler = async () => {
    if (!web3Modal || !web3Modal.cachedProvider) {
      alert("Please check your wallet connection");
      return;
    }
    if (!MemberWhiteList.addresses.includes(address) && saleStatus === 1) {
      notify("You are not whitelisted.");
      return;
    }
    if (remainMintCount < 1) return;
    setMinting(true);
    try {
      const mintFunction = contract.connect(userSigner)["mint"];
      const hash = await mintFunction(address, mintCount, {
        value: parseEther((amount * mintCount).toString()),
      });
      const result = await hash.wait();
      console.log(result);
      setMinting(false);
      notify(mintCount + " NFT(s) minted.");
    } catch (e) {
      console.log(e);
      var errormsg = e.message ? e.message : "Mint Failed.";
      if (errormsg.indexOf("insufficient funds") !== -1)
        errormsg = "Insufficient funds";
      if (errormsg.indexOf("whitelisted") !== -1)
        errormsg = "User is not whitelisted";
      if (errormsg.indexOf("Mint is paused") !== -1)
        errormsg = "Mint is paused";
      if (errormsg.indexOf("Recipient should be present") !== -1)
        errormsg = "Recipient should be present";
      if (errormsg.indexOf("Need to mint at least 1 NFT") !== -1)
        errormsg = "Need to mint at least 1 NFT";
      if (errormsg.indexOf("Royalty value should be positive") !== -1)
        errormsg = "Royalty value should be positive";
      if (errormsg.indexOf("Max mint amount per session exceeded") !== -1)
        errormsg = "Max mint amount per session exceeded";
      notify(errormsg);
      setMinting(false);
    }
  };

  return (
    <>
      {isDesktop && (
        <Stack>
          {!web3Modal.cachedProvider && <ChildTitle title={"NEXT DROP"} />}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            sx={{ borderBottom: "1px solid #ffffff80" }}
          >
            {!web3Modal.cachedProvider && (
              <>
                <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
                  <img
                    src="/assets/LOAI.png"
                    style={{ width: "100%", height: "auto" }}
                  />
                </Stack>
                <Stack
                  spacing={1}
                  justifyContent="center"
                  sx={{ p: "3%", width: { xs: "100%", sm: "50%" } }}
                >
                  <p className="next_count">NEXT 1,000 MEMBERSHIPS</p>
                  <p className="nft_date">
                    TUESDAY <br /> 04.08.22 <br /> 6 PM GMT
                  </p>
                  <p className="add_calendar">Add to your calendar</p>
                </Stack>
              </>
            )}
            {web3Modal && web3Modal.cachedProvider && (
              <>
                <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
                  <img
                    src="/assets/VIKTORIA.png"
                    style={{ width: "100%", height: "auto" }}
                  />
                </Stack>
                <Stack
                  spacing={1}
                  justifyContent="center"
                  sx={{
                    width: { xs: "100%", sm: "50%" },
                    p: { xs: "5%", sm: "0 10% 0 5%" },
                  }}
                >
                  <p className="mint_title">
                    Mint your R/HOOD membership, and get a unique NFT featurying
                    you, with various rarity traits.
                  </p>
                  <Stack
                    alignItems="center"
                    spacing={1}
                    sx={{
                      width: { xs: "100%", sm: "50%" },
                      p: { xs: "7%", sm: "0" },
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={mintNftHandler}
                      sx={{
                        width: "100%",
                        borderRadius: "50px",
                        bgcolor: "#fff",
                        color: "#000",
                        px: "15px",
                        py: "5px",
                        boxShadow: "unset",
                        fontSize: {
                          xs: "24px",
                          sm: "16px",
                          md: "22px",
                        },
                      }}
                    >
                      {minting ? <>MINTING ...</> : <>MINT&nbsp;NOW</>}
                    </Button>
                    <p>{9999 - remainTokenCount}/9999 minted</p>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
          <Stack direction={{ xs: "column", md: "row" }}>
            <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
              <Stack
                sx={{
                  borderBottom: "1px solid #ffffff80",
                  fontFamily: "Helvetica",
                  fontSize: "42px",
                  color: "#fff",
                  lineHeight: 1.1,
                  p: "5%",
                  textAlign: "initial",
                }}
              >
                AN NFT MEMBERSHIP FOR
                <br />
                THE CREATIVE COMMUNITY
              </Stack>
              <Stack spacing={5} sx={{ p: "5% 18% 0 5%" }}>
                <p className="rm_content">
                  Your R/HOOD NFT menbership will be validated in the form of an
                  illustration of you! This is a brand built for the long term,
                  and we want you to be on the journey with us. We chose a
                  personalised illustration of each member to reflect how
                  important each individual is in our community.
                </p>
                <p className="rm_content">
                  We will create a total of 10, 000 memberships with characters
                  and styles specific to local neighbourhoods. Around 33% of
                  them will feature rare traits as an homage to all the Culture
                  Makers that have shaped our community, and the wider world.
                </p>
                <p className="rm_content">
                  Every month we will drop 100 new membership cards. These cards
                  are for application-only members, as we want to curate an
                  engaged and active community.
                </p>
              </Stack>
            </Stack>
            <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
              <img
                src="/assets/MABDULLE.png"
                style={{ width: "100%", height: "auto" }}
              />
            </Stack>
          </Stack>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Stack>
      )}

      {!isDesktop && (
        <Stack sx={{ mt: "90px" }}>
          <ContainerStyle>
            <SubTitleStyle>
              NEXT DROP
              <br />
              TUESDAY 04.10.22
              <br />6 PM GMT
            </SubTitleStyle>
            <Typography
              sx={{
                color: "#fff",
                fontSize: "15px",
                fontFamily: "Helvetica",
                textDecoration: "underline",
              }}
            >
              Add to your calendar
            </Typography>
          </ContainerStyle>

          <Stack>
            <Box
              component="img"
              src="/assets/LOAI.png"
              sx={{ height: "100%", objectFit: "cover" }}
            />
          </Stack>

          <ContainerStyle>
            <ContentStyle>
              Your R/HOOD NFT membership will be validated in the form of an
              illustration of you! This is a brand being built for the long
              term, and we want you to be on the journey with us. We chose a
              personalised illustration of each member to reflect how important
              each individual is in our community.
            </ContentStyle>
            <ContentStyle>
              We will create a total of 10, 000 memberships with characters and
              styles specific to local neighbourhoods. Around 33% of them will
              feature rare traits as an homage to all the Culture Makers that
              have shaped our community, and the wider world.
            </ContentStyle>
            <ContentStyle>
              Every month we will drop 100 new membership cards. These cards are
              for application-only members, as we want to curate an engaged and
              active community.
            </ContentStyle>
          </ContainerStyle>

          <TextFlowStyle>
            <TextFlowContentStyle>
              <TextAStyle>
                &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD
              </TextAStyle>
              <TextBStyle>
                &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR
                NEIGHBORHOOD&nbsp;
              </TextBStyle>
            </TextFlowContentStyle>
          </TextFlowStyle>

          <ContainerStyle>
            <SubTitleStyle>MINT YOUR R/HOOD NFT MEMBERSHIP</SubTitleStyle>
          </ContainerStyle>

          <Stack>
            <Box
              component="img"
              src="/assets/RHOOD2.png"
              sx={{ height: "100%", objectFit: "cover" }}
            />
          </Stack>

          <ContainerStyle sx={{ p: 4 }}>
            <SubTitleStyle sx={{ pb: 3 }}>
              Mint your R/HOOD membership, and get a unique NFT featurying you,
              with various rarity traits.
            </SubTitleStyle>

            <Stack alignItems="center">
              <MintButton
                address={address}
                localProvider={localProvider}
                userSigner={userSigner}
                mainnetProvider={mainnetProvider}
                price={price}
                web3Modal={web3Modal}
                loadWeb3Modal={loadWeb3Modal}
                logoutOfWeb3Modal={logoutOfWeb3Modal}
                blockExplorer={blockExplorer}
                contract={contract}
                remainTokenCount={remainTokenCount}
                remainMintCount={remainMintCount}
                saleStatus={saleStatus}
              />
            </Stack>
          </ContainerStyle>

          <ContainerStyle>
            <TitleStyle>UTILITY</TitleStyle>
          </ContainerStyle>
          <ContainerStyle>
            <ContentStyle sx={{ fontSize: "22px" }}>
              IRL EVENTS. EXCLUSIVE CONTENT. LIMITED EDITION DROPS. SPECIAL
              EDITION MERCH. COLLABS. LIKE-MINDED PEOPLE. GIGS. DISCOUNTS. ART.
              MUSIC. PLACES. EXPERIENCES. MEMORIES. SUPPORT. ALLOWLIST.
              KNOWLEDGE. ALPHA.
            </ContentStyle>
          </ContainerStyle>
        </Stack>
      )}
    </>
  );
}
